import { formatObjectForPayload } from "../apis/util";
import axios from "axios";

// Global API interceptor to automatically format all payloads
const originalFetch = window.fetch;

window.fetch = async function (url, options = {}) {
  // Set API context flag
  window._isApiCall = true;

  // If there's a body and it's JSON, format it automatically
  if (options.body && typeof options.body === "string") {
    try {
      // Try to parse as JSON
      const parsedBody = JSON.parse(options.body);
      const formattedBody = formatObjectForPayload(parsedBody);
      options.body = JSON.stringify(formattedBody);
    } catch (e) {
      // If it's not JSON, leave it as is
    }
  }

  try {
    // Call the original fetch
    return await originalFetch.call(this, url, options);
  } finally {
    // Clear API context flag
    window._isApiCall = false;
  }
};

// Also intercept XMLHttpRequest for older code
const originalXHROpen = XMLHttpRequest.prototype.open;
const originalXHRSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function (method, url, ...args) {
  this._method = method;
  this._url = url;
  return originalXHROpen.call(this, method, url, ...args);
};

XMLHttpRequest.prototype.send = function (data) {
  // Set API context flag
  window._isApiCall = true;

  try {
    if (data && typeof data === "string") {
      try {
        // Try to parse as JSON and format
        const parsedData = JSON.parse(data);
        const formattedData = formatObjectForPayload(parsedData);
        data = JSON.stringify(formattedData);
      } catch (e) {
        // If it's not JSON, leave it as is
      }
    }

    return originalXHRSend.call(this, data);
  } finally {
    // Clear API context flag
    window._isApiCall = false;
  }
};

// Axios interceptor for request data formatting
axios.interceptors.request.use(
  function (config) {
    // Set API context flag
    window._isApiCall = true;

    // Format the data if it exists and is a string (JSON)
    if (config.data && typeof config.data === "string") {
      try {
        const parsedData = JSON.parse(config.data);
        const formattedData = formatObjectForPayload(parsedData);
        config.data = JSON.stringify(formattedData);
      } catch (e) {
        // If it's not JSON, leave it as is
      }
    }
    return config;
  },
  function (error) {
    // Clear API context flag on error
    window._isApiCall = false;
    return Promise.reject(error);
  }
);

// Axios interceptor for response to clear API context flag
axios.interceptors.response.use(
  function (response) {
    // Clear API context flag
    window._isApiCall = false;
    return response;
  },
  function (error) {
    // Clear API context flag on error
    window._isApiCall = false;
    return Promise.reject(error);
  }
);

console.log(
  "🌍 Global API interceptor activated - all API calls (fetch, axios, xhr) automatically use dot format for numbers"
);
